import React, {Component} from 'react';
import './CustomerItemTableRow.css';
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import ViewItemDetails from "../../../../Admin/Order/ViewSingleCustomerOrder/ViewItemDetails/ViewItemDetails";
import ReactImageZoom from "react-image-zoom";

const ImageView = (props) => {
    if (props.imagePath) {
        const imgProps = {
            "width": 120, "scale": 2.5, "img": props.imagePath, "offset": {"vertical": -100, "horizontal": 10},
            "border": "1px solid #ececec", "z-index":5000000
        };
        return (
            <div className="cart-item-preview-image">
                <ReactImageZoom className="cart-item-preview-image" {...imgProps} />
            </div>
        );
    } else {
        return <span>X</span>
    }
};

class CustomerItemTableRow extends Component {

    render() {
        let pcbParams ={};
        let stencilParams ={};
        let dimensions = "";

        if(this.props.orderInfo.quotation.orderType === 1){
            pcbParams = this.props.orderInfo.quotation.pcbParam;
            dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
                pcbParams.width + "*" + pcbParams.length + "" : '';
        }
        else if(this.props.orderInfo.quotation.orderType === 2){
            pcbParams = this.props.orderInfo.quotation.pcbParam;
            stencilParams = this.props.orderInfo.quotation.stencilParam;
            dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
                pcbParams.width + "*" + pcbParams.length + "" : '';
        }
        else {
            stencilParams = this.props.orderInfo.quotation.stencilParam;
        }


        return (
            <div>
                <div className="row admin-single-order-item-row-margin">
                    <div className="col-md-2">
                        {/*<span>*/}
                            {/*{this.props.no}*/}

                        {/*</span>*/}
                        <span>{this.props.orderInfo.itemName}</span>
                    </div>
                    <div className="col-md-3">
                        <ImageView imagePath={this.props.orderInfo.imageUrlFront}/>
                    </div>
                    {/*<div className="col-md-2">*/}
                        {/*<span>{this.props.orderInfo.itemName}</span>*/}
                    {/*</div>*/}
                    <div className="col-md-2">
                        <span>

                            {this.props.orderInfo.quotation.orderType === 1 &&
                            <p>{pcbParams.qty}</p>
                            }
                            {this.props.orderInfo.quotation.orderType === 2 &&
                            <p>{pcbParams.qty},{stencilParams.stencilQty}</p>
                            }
                            {this.props.orderInfo.quotation.orderType === 3 &&
                            <p>{stencilParams.stencilQty}</p>
                            }

                            {/*{this.props.orderInfo.quantity}*/}
                        </span>
                    </div>
                    <div className="col-md-2">
                        <span className=" admin-order-view-table-cost pull-left">
                           
                            {/*<NumberFormatter num={this.props.price}/>*/}
                            <NumberFormatter num={this.props.orderInfo.unitPrice}/>
                        </span>
                    </div>
                    <div className="col-md-1">
                        <span className="pull-left">
                            <NumberFormatter num={this.props.orderInfo.chargeDetails.weight}/>
                        </span>
                    </div>
                    <div className="col-md-2">
                        <ViewItemDetails orderType={this.props.orderInfo.quotation.orderType}
                                         itemDetails={this.props.orderInfo}/>
                    </div>

                    <br/>
                </div>
            </div>
        )
    }
}

export default CustomerItemTableRow;



// WEBPACK FOOTER //
// ./src/components/Site/Order/SingleOrder/CustomerItemTableRow/CustomerItemTableRow.js